define('modules/editor/behaviours/has_property_groups',['require','exports','module','backbone','../models/property_group_factory','../models/editorstate','base/vent'],function(require, exports, module) {

  var Backbone = require("backbone"),
      PropertyGroupFactory = require("../models/property_group_factory"),
      EditorState = require("../models/editorstate"),
      Vent = require("base/vent");

  module.exports = {
    _initializePropertyGroups: function() {
      //console.log("PG init", this.name);
      this.propertyGroups = _.map(this.propertyGroups, function(description) {
        return PropertyGroupFactory.create(description.name,
                                           description.defaults, this);
      }, this);
      // An intermediary vent give us more control of what is
      // actually fowraded to the model vent.
      this._propertyVent.stopListening();
      this._propertyVent.forwardAll(this.propertyGroups);
      this.listenTo(this, "notify:stop", function(){
        this._notify = false;
      });
      this.listenTo(this, "notify:start", function(){
        this._notify = true;
        EditorState.setVariantChanged(true);
      });
      this.listenTo(this._propertyVent, "change", function(pg){
        if (!pg) return;
        if (this._notify) EditorState.setVariantChanged(true, true);
      });
      //NOTE: stop forwarding to avoid unnecesary re-render, not needed anymore
      //this.forward(this._propertyVent);
    },
    initPropertyGroupsWithDefaults: function () {
      if (this.propertyGroups && this.defaultPropertyGroups) {
        this.propertyGroups = _.union(this.defaultPropertyGroups, this.propertyGroups);
      }
    },
    getPropertyGroups: function() {
      return this.propertyGroups;
    },
    getPropertyGroup: function(name) {
      return _.foldl(this.propertyGroups, function(acc, group) {
        return (!acc && group.name === name)? group : acc;
      }, false);
    },
    setPropertyGroups: function (newPropertyGroups, options) {
      var notify = this._notify;
      if (options && options.silenceNotify) this._notify = false; 
      _.each(newPropertyGroups, this.setPropertyGroup, this);
      this._notify = notify;
    },
    setPropertyGroup: function (newPropertyGroup) {
      var name = newPropertyGroup.name,
        propertyGroupModel;
      if (name) {
        propertyGroupModel = this.getPropertyGroup(name);
        if (propertyGroupModel.set) {
          propertyGroupModel.set(_.omit(newPropertyGroup, 'name'));
        }
      }
    },
    mixed: function(klass) {
      var proto = klass.prototype;
      proto.initialize = _.wrap(proto.initialize || _.identity, function(init) {
        this._propertyVent = new Vent();
        this._initializePropertyGroups();
        this._notify = true;
        return init.apply(this, _.rest(arguments));
      });
    }
  };
});

